import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import useFetchData from '../hooks/useFetchData';

function formatDate(dateString, lang) {
  return new Date(dateString).toLocaleDateString(lang === 'es' ? 'es-ES' : 'en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

function Blog() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith('es') ? 'es' : undefined;
  const { data: posts, loading, error } = useFetchData('/api/posts/', lang);

  if (loading) return <div className="text-center p-10">{t('common.loading')}</div>;
  if (error) return <div className="text-center p-10 text-red-500">{error}</div>;
  if (!posts) return null;

  return (
    <div>
      <h1 className="text-4xl font-bold tracking-tight border-t-[3px] border-slate-900 pt-3 mb-12 text-slate-900">
        {t('blog.heading')}
      </h1>
      <div className="space-y-16">
        {posts.map(post => (
          <article key={post.id} className="pt-12 first:pt-0 border-t-[3px] first:border-t-0 border-slate-900">
            <h2 className="text-3xl font-bold leading-tight text-slate-900 mb-2">{post.title}</h2>
            <p className="font-mono text-xs tracking-[0.08em] uppercase text-slate-500 mb-8">
              {t('blog.byLine', { author: post.author, date: formatDate(post.createdAt, lang) })}
            </p>
            <div
              className="prose prose-slate max-w-none
                prose-headings:font-bold prose-headings:text-slate-900
                prose-p:leading-relaxed
                prose-strong:text-slate-900 prose-strong:font-semibold
                prose-a:text-slate-900 prose-a:underline prose-a:decoration-2 prose-a:underline-offset-2
                prose-blockquote:border-l-[3px] prose-blockquote:border-slate-900 prose-blockquote:pl-6
                prose-blockquote:not-italic prose-blockquote:font-medium prose-blockquote:text-slate-800
                prose-li:marker:text-slate-400"
            >
              <ReactMarkdown>{post.content}</ReactMarkdown>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

export default Blog;
